import { useRef } from "react";
import { useAPI } from "@huub-web/backend";

type SoftDeleteResult = {
  deletedAt: string;
  fallsBackTo: string | null;
};

/**
 * Encapsulates API calls for the History panel:
 * soft-delete a photo and navigate to a different tree node.
 */
export function useHistoryActions(): {
  softDelete: ({ photoId }: { photoId: string }) => Promise<SoftDeleteResult>;
  navigateToNode: ({ photoId }: { photoId: string }) => Promise<void>;
} {
  const { $post } = useAPI();
  const $postRef = useRef($post);
  $postRef.current = $post;

  const softDelete = async ({
    photoId,
  }: {
    photoId: string;
  }): Promise<SoftDeleteResult> => {
    const response: {
      data: { deleted_at: string; falls_back_to: string | null };
    } = await $postRef.current(
      `/interior-designer/photo/${photoId}/soft-delete`,
    );
    return {
      deletedAt: response.data.deleted_at,
      fallsBackTo: response.data.falls_back_to,
    };
  };

  const navigateToNode = async ({
    photoId,
  }: {
    photoId: string;
  }): Promise<void> => {
    await $postRef.current(`/interior-designer/photo/${photoId}/navigate`);
  };

  return { softDelete, navigateToNode };
}
